/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import EmployeeContext from 'domain/people/employee/EmployeeContext';
import UserSettings from './createupdate/Update';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { ProtectedRouter } from 'infrastructure/routing';
import { Router, Route } from 'framework/routing';

export const USER_SETTINGS_PATH = '/settings';

const UserSettingsRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const [userAlias, setUserAlias] = useState<Nullable<string>>(null);
  const { getUserAlias } = useAuthenticatedUserService();

  useEffect(() => {
    (async () => {
      const alias = await getUserAlias();
      setUserAlias(alias);
    })();
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route
        path=""
        element={
          <ProtectedRouter>
            <EmployeeContext id={userAlias || ''}>
              <UserSettings />
            </EmployeeContext>
          </ProtectedRouter>
        }
      />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

UserSettingsRouter.getRouterPath = () => USER_SETTINGS_PATH;

export default UserSettingsRouter;
